import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';
import { observer } from 'mobx-react';

const BannersQuery = gql`
  query {
    banners {
      id
      type
      file
      productImage
      title
      subtitle
      description
      link
    }
    languages {
      id
      value
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

@observer
class GetBannersQuery extends React.Component<ChildProps<IInputProps, IResponse>, {}> {
  public render() {
    const { banners }: any = this.props;
    return this.props.children({ banners });
  }
}

export default compose(
  graphql<IInputProps, IResponse>(BannersQuery, {
    name: 'banners'
  })
)(GetBannersQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Banners/Banners.tsx